





























import { Component, Mixins, Prop } from "vue-property-decorator";
import { Mixin } from "@/core/mixins/mixin";
import { Button } from "vant";

@Component({
  components: {
    [Button.name]: Button,
  },
})
export default class CouponLayout2 extends Mixins(Mixin) {
  @Prop({
    type: Array,
    default: () => {
      return [];
    },
  })
  public couponList!: cms.SubjectCouponInfoDto[];

  receive(item: cms.SubjectCouponInfoDto) {
    this.$emit("receive", item);
  }
}
